import { takeLatest } from 'redux-saga/effects';
import { LANG_ACTION_TYPE, ChangeLanguageAction } from './lang-type';

export function* changeLanguage(value: ChangeLanguageAction) {
  yield localStorage.setItem('localLanguage', value.payload.data);
}

export const langSagas = {
  watchers: [
    takeLatest(LANG_ACTION_TYPE.CHANGE_LANGUAGE, changeLanguage),
  ]
};
